import React from 'react';
import {Constants} from 'commons/constants';
import {Bullet} from 'commons/models';
import {ReactComponent as DownloadIcon} from 'assets/icons/section/action/download.svg';

const guideLineSection = {
    context:
        'Se considera PROPIETARIO REAL a la P.F. que ejerza el CONTROL sobre el Cliente mediante alguno de los siguientes supuestos:',
    sectionI: {
        header: '<b1> I. La PROPIEDAD DE VALORES O PARTICIPACI\u00D3N EN LA COMPOSICI\u00D3N ACCIONARIA O CAPITAL SOCIAL:',
        index: {
            a: 'a) Persona F\u00EDsica que directa o indirectamente, sea titular o posea el 25% o m\u00E1s de la composici\u00F3n accionaria o parte social del capital social de una Persona Moral. ',
            b: 'b) Accionista o socio Persona F\u00EDsica que sea titular, posean o adquieran la propiedad de valores de forma directa o indirecta, en copropiedad o cotitularidad con otros accionistas o socios mediante un contrato celebrado de forma individual o conjunta.',
        },
    },
    sectionII: {
        header: '<b1> II. El CONTROL QUE TENGA SOBRE LA SOCIEDAD, POR LAS FACULTADES CON LAS QUE CUENTA:',
        index: {
            c: 'c) Persona F\u00EDsica facultada para imponer directa o indirectamente decisiones en la asamblea general de accionistas o de socios en el \u00F3rgano de gobierno de una Persona Moral. ',
            d: 'd) Persona F\u00EDsica facultada para nombrar o destituir a la mayor\u00EDa de los consejeros, administradores o equivalentes de una Persona Moral.',
            e: 'e) facultada para mantener la titularidad de derechos que permitan, directa o indirectamente, ejercer el voto respecto de más del 50% del capital social.'
        },
    },
    sectionIII: {
        header: '<b1> III. El CONTROL QUE TENGA DE LA SOCIEDAD POR EL CARGO QUE SE EJERCE: ',
        index: {
            f: 'f) Persona F\u00EDsica facultada para dirigir, directa o indirectamente, la administraci\u00F3n, la estrategia o las principales pol\u00EDticas, a través de un cargo directivo de administrador, director general, gerente, presidente, vicepresidente, tesorero, entre otros.',
        },
    },
    sectionIV: {
        header: '<b1> IV.  A través de CUALQUIER OTRO MEDIO: ',
        index: {
            g: 'g) Persona F\u00EDsica SIN la propiedad de valores, que tiene participaci\u00F3n en las finanzas de una Persona Moral, que tenga alguna relaci\u00F3n personal o v\u00EDnculo familiar con los altos mandos de la misma o que tenga algún derecho de propiedad, entre otros, que goza de los beneficios de una cuenta, contrato u operaci\u00F3n y es, en última instancia, el verdadero dueño de los recursos, al tener sobre estos derechos de uso, disfrute, aprovechamiento, dispersi\u00F3n o disposici\u00F3n.',
        },
    },
};

export const data: Array<Bullet> = [
    {
        desc: 'Para identificar a los Propietarios Reales, se deber\u00E1n considerar las siguientes definiciones:',
        items: [
            {
                item: 1,
                sections: [
                    {
                        value: 'a) Aquella Persona F\u00EDsica que, por medio de otra o de cualquier acto o mecanismo, obtiene los beneficios derivados de una cuenta, contrato u Operaci\u00F3n y es, en \u00FAltima instancia, el verdadero due\u00F1o de los recursos, al tener sobre \u00E9stos, derechos de uso, disfrute, aprovechamiento, dispersi\u00F3n o disposici\u00F3n.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 2,
                sections: [
                    {
                        value: 'b) Aquella Persona F\u00EDsica o Grupo de Personas que, ejerzan el Control sobre una Persona Moral, as\u00ED como, en su caso, a las personas que puedan instruir o determinar, para beneficio econ\u00F3mico Propio, los actos susceptibles de realizarse a través de Fideicomisos, Mandatos o Comisiones.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
        ],
    },
];

export const guidelines: Array<Bullet> = [
    {
        desc: '',
        secondaryLink: true,
        items: [
            {
                item: 0,
                sections: [
                    {
                        value: 'Gu\u00EDa del Propietario Real',
                        title: 'Gu\u00EDa del Propietario Real',
                        headerActions: [
                            {
                                id: Constants.GUIA_PROPIETARIO_REAL,
                                icon: <DownloadIcon />,
                            },
                        ],
                        style: 'modal',
                        order: 0,
                        variant: 'link',
                        text: `${guideLineSection.context} 
                        | ${guideLineSection.sectionI.header} 
                        | ${guideLineSection.sectionI.index.a} 
                        | ${guideLineSection.sectionI.index.b} 
                        | ${guideLineSection.sectionII.header} 
                        | ${guideLineSection.sectionII.index.c}
                        | ${guideLineSection.sectionII.index.d} 
                        | ${guideLineSection.sectionII.index.e} 
                        | ${guideLineSection.sectionIII.header} 
                        | ${guideLineSection.sectionIII.index.f} 
                        | ${guideLineSection.sectionIV.header} 
                        | ${guideLineSection.sectionIV.index.g}`,
                    },
                ],
            },
        ],
    },
];

export const realOwnerControl: Array<Bullet> = [
    {
        desc: 'Control:',
        items: [
            {
                item: 1,
                sections: [
                    {
                        value: 'a)  Imponer, directa o indirectamente, decisiones en la asamblea general de accionistas o de socios o en el \u00F3rgano de gobierno o su equivalente;',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 2,
                sections: [
                    {
                        value: 'b) Nombrar o destituir a la mayor\u00EDa de los consejeros, administradores o equivalentes;',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 3,
                sections: [
                    {
                        value: 'c) Mantener la titularidad de derechos que permitan, directa o indirectamente, ejercer el voto respecto de m\u00E1s del cincuenta por ciento del capital social, y',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 4,
                sections: [
                    {
                        value: 'd) Dirigir, directa o indirectamente, la administraci\u00F3n, la estrategia o las principales pol\u00EDticas.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
        ],
    },
];
